/** Organization datagrid key base — full key is `${DESIGNATIONS_DATAGRID_KEY}_${organizationId}` */
export const DESIGNATIONS_DATAGRID_KEY = "Designations_grid";

export const DESIGNATION_DEFAULT_COLUMNS = [
  {
    field: "designation_name",
    label: "Designation",
    visible: true,
    width: 180,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "designation_short_name",
    label: "Designation Short Name",
    visible: true,
    width: 160,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "departmentName",
    label: "Department Name",
    visible: true,
    width: 200,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
];

export const DESIGNATION_PERSONALIZE_CONFIG = {
  defaultVisibleColumns: DESIGNATION_DEFAULT_COLUMNS.map((col) => col.field),
  columnLabels: Object.fromEntries(
    DESIGNATION_DEFAULT_COLUMNS.map((col) => [col.field, col.label])
  ),
  columnWidths: Object.fromEntries(
    DESIGNATION_DEFAULT_COLUMNS.map((col) => [col.field, col.width])
  ),
};

export const DESIGNATION_PERSONALIZE_COLUMN_KEYS =
  DESIGNATION_DEFAULT_COLUMNS.map((col) => col.field);

const COLUMN_FIELD_ALIASES = {
  department: "departmentName",
  department_name: "departmentName",
  name: "designation_name",
};

export function normalizeDesignationColumnField(field) {
  const raw = String(field || "").trim();
  if (!raw) return raw;
  if (COLUMN_FIELD_ALIASES[raw]) return COLUMN_FIELD_ALIASES[raw];
  const lower = raw.toLowerCase();
  return COLUMN_FIELD_ALIASES[lower] || raw;
}

export function resolveDesignationApiField(field) {
  const normalized = normalizeDesignationColumnField(field);
  if (normalized === "departmentName") return "department";
  return normalized;
}

export function mapSavedDesignationColumns(savedColumns = []) {
  const labelByField = DESIGNATION_PERSONALIZE_CONFIG.columnLabels || {};

  return savedColumns
    .map((col) => {
      const field = normalizeDesignationColumnField(col.field || col.key);
      if (!field || field === "organization_designation_id") return null;

      const defaultCol = DESIGNATION_DEFAULT_COLUMNS.find(
        (c) => c.field === field
      );

      return {
        ...(defaultCol || {}),
        ...col,
        field,
        key: field,
        label: col.label || labelByField[field] || field,
        visible: col.visible !== false,
        filterable: col.filterable !== false,
        sortable: col.sortable !== false,
      };
    })
    .filter(Boolean);
}
